module.exports = __webpack_public_path__ + "static/Reiterhof2-19a481701e46fcf1ad1ba2d98b072d62.jpg";